import React from "react"
import type { ICheckoutEquipment } from "../../interface";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useLang } from "~/hooks/useLang";

interface TableEquipmentsProps {
  readonly equipments: readonly ICheckoutEquipment[];
  readonly status?: number;
}

const statusText = {
  disposed: 'Disposed',
  lost: 'Lost',
  returnedDamaged: 'Returned Damaged',
} as const

type StatusKey = keyof typeof statusText

export default function TableEquipments({ equipments, status }: TableEquipmentsProps) {
  const { translate } = useLang();

  function getStatusEquipment(equipment: ICheckoutEquipment): string {
    const statusKey: StatusKey = equipment.disposed
      ? 'disposed'
      : equipment.lost
        ? 'lost'
        : 'returnedDamaged'
    return translate(statusText[statusKey])
  }

  const columnNames = [
    { key: 'name', nameColumn: translate('Name'), statusView: [1, 2, 3, 4, 5] },
    { key: 'equipmentGroup', nameColumn: translate('Equipment Group'), statusView: [1, 2, 3, 4, 5] },
    { key: 'serial_number', nameColumn: translate('Material group'), statusView: [1, 2, 3, 4, 5] },
    { key: 'situation', nameColumn: translate('Situation'), statusView: [2, 3, 4, 5] },
    { key: 'Notes', nameColumn: translate('Notes'), statusView: [2, 3, 4, 5] },
  ]

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 300 }}>
      <Table size="small" stickyHeader sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            {columnNames.map((column) => (
              column.statusView.includes(status ?? 0) && (
                <TableCell key={column.key}>
                  <strong>
                    {column.nameColumn}
                  </strong>
                </TableCell>
              )
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {equipments.length > 0 ? (
            equipments.map((equipment: ICheckoutEquipment) => {
              const rowsNames = [
                { key: 'name', value: equipment.equipment.name, statusView: [1, 2, 3, 4, 5] },
                { key: 'equipmentGroup', value: equipment.equipment.equipmentGroup.name, statusView: [1, 2, 3, 4, 5] },
                { key: 'serial_number', value: equipment.equipment.serialNumber , statusView: [1, 2, 3, 4, 5] },
                { key: 'situation', value: getStatusEquipment(equipment), statusView: [2, 3, 4, 5] },
                { key: 'Notes', value: equipment.notes, statusView: [2, 3, 4, 5] },
              ]

              return (
                <TableRow key={equipment.id}>
                  {rowsNames.map((cell) => (
                    cell.statusView.includes(status ?? 0) && (
                      <TableCell key={cell.key}>
                        {cell.value}
                      </TableCell>
                    )
                  ))}
                </TableRow>
              )
            })
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="center">
                {translate('No Equipment found')}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}